export default "__VITE_ASSET__CFci1O10__"